// extracted by mini-css-extract-plugin
export var filterIncDec = "_dh-0";
export var leftBorder = "_dh-1";
export var rightBorder = "_dh-2";
export var stringInput = "_dh-3";